import {web3} from '../providers';
import {Contract} from 'web3-eth-contract';
import { AbiItem } from 'web3-utils';
import { abi as ParrotPassAbi } from './ParrotPass.json';
import { config } from '../apps/config';

export function getParrotPassContract(): Contract | undefined {
  if (web3) {
      return new web3.eth.Contract(
        ParrotPassAbi as AbiItem[],
        config.metaMask.contractAddresses?.parrotPass,
      );
  }
  return undefined;
}

